export const Footer = () => (
  <footer className="bg-white border-t border-slate-200 py-10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-center justify-between gap-4">
      <img src="/hp-logo.png" alt="HP" className="h-9 w-auto" />
      <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-slate-500">
        Gen 1 → Gen 2 Migration Program · VideoOS 5.0
      </p>
      <div className="flex items-center gap-4">
        <p className="text-xs text-slate-500">Concept campaign page. Product names belong to HP Inc.</p>
        <a href="/admin" data-testid="footer-admin-link" className="text-xs font-medium text-slate-600 hover:text-slate-900 transition-colors">Admin</a>
      </div>
    </div>
  </footer>
);
